import Icon from 'components/Icon';
import Select from 'components/Inputs/Select';
import Textarea from 'components/Inputs/Textarea';
import SimplePopup from 'components/SimplePopup';
import { ClusterModelType } from 'models/ClusterModel';
import { PainpointModelType } from 'models/PainpointModel';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import PainpointsListItem from 'screens/painpoints/PainpointsListScreen/PainpointsListItem';
import { ROUTE_FIRE } from 'utils/constants/routes';
import useForm from 'utils/hooks/useForm';

interface ClusterWithPainpointComponentProps {
  cluster: ClusterModelType;
  clusters: { id: number; name: string }[];
  painpoints: PainpointModelType[];
  onAiButtonClick: () => void;
  onAddPainpointClick: (newPainpoint: {
    question: string;
    cluster_id: number;
  }) => void;
  organizationId: number;
  projectId: number;
  fireId: number;
  handlePainpointChange: (
    painpoint: PainpointModelType,
    checked: boolean
  ) => void;
  editable: boolean;
  checked: number[];
}

const ClusterWithPainpointComponent: React.FC<
  ClusterWithPainpointComponentProps
> = ({
  cluster,
  clusters,
  painpoints,
  onAiButtonClick,
  onAddPainpointClick,
  organizationId,
  projectId,
  fireId,
  handlePainpointChange,
  editable,
  checked
}) => {
  const [showAddPainpointOverlay, setShowAddPainpointOverlay] = useState(false);
  const form = useForm();

  useEffect(() => {
    form.setField('cluster_id', cluster.id);
  }, [cluster]);

  if (!cluster) {
    return null;
  }

  if (showAddPainpointOverlay) {
    return (
      <SimplePopup
        onAbort={() => setShowAddPainpointOverlay(false)}
        onSubmit={() => {
          onAddPainpointClick({
            question: form.values.question,
            cluster_id: form.values.cluster_id
          });
          setShowAddPainpointOverlay(false);
        }}
        headlineTextId="fire painpoint"
        submitTextId="Save"
      >
        <>
          <Select
            name="cluster_id"
            normalFont={true}
            label={<FormattedMessage id="Cluster" />}
            {...form.bindInput('cluster_id')}
          >
            {clusters.map((cluster: { id: number; name: string }) => (
              <option value={cluster.id} key={cluster.id}>
                {cluster.name?.toString().toUpperCase() || '-'}
              </option>
            ))}
          </Select>
          <p>&nbsp;</p>

          <Textarea
            autoFocus={true}
            lines={3}
            normalFont={true}
            label={<FormattedMessage id="painpoint question" />}
            predefined_text={
              <FormattedMessage id="painpoint question prefix" />
            }
            name="question"
            {...form.bindInput('question')}
          />
        </>
      </SimplePopup>
    );
  }
  return (
    <div className="cluster-container">
      <h3 className="cluster-title">{cluster.name} <span className="cluster-title-count">({painpoints.length})</span></h3>
      <div className="painpoints-wrapper">
        <div className="painpoints-scroll">
          {painpoints.map((painpoint) => {
            if (editable) {
              return (
                <PainpointsListItem
                  key={painpoint.id}
                  painpoint={painpoint}
                  contextUri={`/app/lab/${organizationId}/${projectId}`}
                  onChange={(c) => handlePainpointChange(painpoint, c)}
                  checked={checked.indexOf(painpoint.id) > -1}
                  fireBackRoute={ROUTE_FIRE + '/' + organizationId + '/' + fireId + '#painpoints'}
                />
              );
            } else {
              return (
                <PainpointsListItem
                  key={painpoint.id}
                  painpoint={painpoint}
                  contextUri={`/app/lab/${organizationId}/${projectId}`}
                />
              );
            }
          })}
        </div>
        {editable && (
          <div className="ai-button-container">
            <button
              className="add-card-button"
              onClick={() => {
                onAiButtonClick();
              }}
            >
              <Icon name="ai" size="large" />
            </button>
            <button
              className="add-card-button"
              onClick={() => {
                setShowAddPainpointOverlay(true);
              }}
            >
              <Icon name="plus" size="large" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ClusterWithPainpointComponent;
